import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const AiFindingsRoute = LazyLoad(
  lazy(() => import('./ai-findings.component').then((module) => ({ default: module.AiFindings }))),
);
